<template>
  <!-- 企业实名认证 -->
  <div class="person-auth-root">
    <div class="box">
      <!-- 步骤条 -->
      <div class="step-box">
        <div class="font-family font-21 step1">01基本信息</div>
        <div
          class="font-family font-21"
          :class="{
            'un-start': authStep == 1,
            doing: authStep > 1,
          }"
        >02选择认证方式</div>
        <div
          class="font-family font-21"
          :class="{
            'un-start': authStep < 3,
            doing: authStep == 3,
          }"
        >{{ approveStatus == 0 ? "03人工审核" : "03认证完成" }}</div>
      </div>
      <!-- 步骤条 end -->
      <!-- step1 基本信息 -->
      <div v-show="authStep == 1">
        <div class="info-box">
          <el-form
            ref="authForm"
            :model="enterprise"
            :rules="enterpriseRules"
            label-position="left"
            label-width="150px"
          >
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input
                class="input-width"
                placeholder="请输入企业名称"
                v-model="enterprise.enterpriseName"
                :readonly="isInDingTalk"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="email">
              <el-input class="input-width" placeholder="请输入邮箱号码" v-model="enterprise.email"></el-input>
            </el-form-item>
            <!-- <el-form-item label="密码：" prop="password">
              <el-input
                class="input-width"
                placeholder="请输入密码"
                show-password
                v-model="enterprise.password"
              ></el-input>
            </el-form-item>-->
            <el-form-item label="验证码：" prop="code_copy">
              <el-input
                v-model="enterprise.code_copy"
                class="input-width"
                auto-complete="off"
                placeholder="输入验证码"
              >
                <template slot="append">
                  <span class="img-code" @click="getImgCode">
                    <img :src="'data:image/png;base64,' + imgAuth.imgPath" />
                  </span>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 基本信息 end -->
      <!-- step2 认证方式 -->
      <div class="stpe-mainland" v-show="authStep == 2">
        <div class="auth-box" v-if="!showAuthList">
          <div @click="handAuthList(1)">
            <div class="auth-type" :class="authType === 1 ? 'red-border' : ''">
              <img src="/images/add_now2.png" alt />
              <p class="font-title">快速认证</p>
            </div>
            <p>使用君子签SaaS已有帐号进行认证</p>
          </div>
          <div
            class="auth-type"
            :class="authType === 2 ? 'red-border' : ''"
            @click="handAuthList(2)"
          >
            <img src="/images/add_now2.png" alt />
            <p class="font-title">在线认证</p>
          </div>
        </div>
        <!-- 快速认证列表 -->
        <div v-if="showAuthList">
          <p class="font-title">快速认证：</p>
          <div class="list-box">
            <div
              class="auth-list"
              v-for="item of accontList"
              :key="item.emailSec"
              :class="
                selectAccont.emailSec === item.emailSec ? 'active-auth' : ''
              "
              @click="chooseAccont(item)"
            >
              <p>企业名称：{{ item.name }}</p>
              <p>统一社会信用代码：{{ item.business_license }}</p>
              <p>账号：{{ item.email }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- step2 认证方式 end -->
      <!-- step3 认证完成 -->
      <div class="stpe-end" v-show="authStep == 3">
        <!-- 成功 -->
        <div class="res-icon" v-if="authentication !== 4">
          <div v-if="approveStatus == 0">
            <!-- 授权书认证（authentication == 3）  状态为 0 表示还在审核中 -->
            <img src="/images/auth/authIcon/clock.png" alt />
            <p class="text">正在审核中，请耐心等待</p>
            <p class="text">您还可以拨打4008089187联系人工审核</p>
          </div>
          <div v-else>
            <img src="/images/auth/authIcon/suc.png" alt />
            <p class="text">实名认证成功</p>
          </div>
        </div>
      </div>
      <!-- step3 认证完成 end -->
      <!-- 步骤按钮 -->
      <div class="step-btn">
        <div style="margin-top: 10px">
          <el-button type="danger" plain v-show="authStep == 2" @click="previous">上一步</el-button>
          <!-- <el-button type="danger" v-show="authStep == 1" @click="nextStep"
            >下一步</el-button
          >-->
          <!-- <el-button type="danger" v-show="authStep == 2" @click="authSubmit"
            >立即绑定</el-button
          >-->
          <el-button type="danger" v-show="authStep == 1" @click="authSubmit">立即绑定</el-button>
          <el-button type="danger" v-show="authStep == 3" @click="confirm">完成</el-button>
        </div>
      </div>
      <!-- 步骤按钮 end -->
    </div>
  </div>
</template>

<script>
/* 组件 */

// API
import {
  ApiMethods,
  postImgCode,
  checkTargetExists
} from "../../assets/js/http-serve/http-methods";
import { loginOrRefresh } from "@/assets/js/http-serve/corp/common";
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import {
  mobile,
  email,
  password,
  imgAuth
} from "@/assets/js/lib/valid-methods";
//
import Cookie from "@/assets/js/lib/cookie";
import GlobalConfig from "@/assets/js/config/global";
const base64 = require("js-base64").Base64;

export default {
  data () {
    return {
      isInDingTalk,
      selectAccont: {}, // 选中的快速认证item
      accontList: [], // 快速认证 列表
      authType: 2, // 认证方式 1 快速认证 2 在线认证
      backUrl: "", // 认证成功后跳转地址
      approveStatus: null, //data: 0 待审核 1审核通过 2审核不通过 -1未提交资料
      // step2
      authentication: 1,
      // step1
      authStep: 1,
      imgAuth: "",
      showAuthList: false,
      enterprise: {
        enterpriseName: "",
        email: "",
        password: "",
        imgCode: "",
        code_copy: ""
      },
      enterpriseRules: {
        email: [
          { required: true, message: "请设置登录账号", trigger: "blur" },
          { validator: email, trigger: "change" },
          // { validator: this.vaildEmailExit, trigger: "blur" }
        ],
        code_copy: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: imgAuth, trigger: "change" }
        ],
        password: [
          { required: true, message: "请设置登录密码", trigger: "blur" },
          { validator: password, trigger: "change" }
        ],
        enterpriseName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" }
        ]
      },
      // API
      authApi: ApiMethods.IdenAuthController
    };
  },
  // data end
  methods: {
    // 快速认证选择
    chooseAccont (item) {
      this.selectAccont = item;
    },
    // 上一步
    previous () {
      this.selectAccont = {};
      this.showAuthList = false;
      --this.authStep;
    },
    // 下一步
    nextStep () {
      const corpId = sessionStorage.getItem("corpId"),
        _this = this;
      this.$refs.authForm.validate(vaild => {
        if (vaild) {
          const param = {
            corpId,
            dingTalkUserId: this.dingloginInfo.dingTalkUserId,
            page: 1,
            pageSize: 999
          };
          dingtalkApi.accontList(param).then(res => {
            if (!res.success)
              _this.$message.error(res.description || "网络异常");
            _this.accontList = res.data;
            _this.enterprise.imgCode =
              _this.imgAuth.imgToken + "_" + _this.enterprise.code_copy;
            ++_this.authStep;
          });
        }
      });
    },
    nextTwo () { },
    authSubmit () {
      const active = Object.keys(this.selectAccont),
        _this = this;
      if (!this.authType) {
        this.$message.error("请选择要进行认证的方式");
        return false;
      }
      if (this.authType === 1 && active.length === 0 && this.showAuthList) {
        this.$message.error("请选择要进行认证的企业");
        return false;
      }
      this.loadingStart();
      const corpId = sessionStorage.getItem("corpId"),
        { dingTalkUserId } = this.dingloginInfo;
      const param = {
        corpId,
        dingTalkUserId,
        email: this.enterprise.email,
        password: this.enterprise.password
      };
      if (this.authType === 1)
        param.fastVerifyEmail = this.selectAccont.emailSec;
      dingtalkApi.entReplenish(param).then(res => {
        if (!res.success) {
          if(res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
          return this.$message.error(res.description)
        };
        const newInfo = Object.assign(this.dingloginInfo, res.data);
        sessionStorage.setItem("dingloginInfo", JSON.stringify(newInfo));
        // this.loadingClose();
        _this.$router.replace({ path: '/login/middle', query: { corpId } })
        if (res.data.identityAuth === 1) _this.authStep = 3;
      }).finally(() => { this.loadingClose() });
    },
    confirm () { },
    /**
     * @param type 1 快速认证 2 在线认证
     */
    handAuthList (type) {
      this.authType = type;
      if (type === 1) this.showAuthList = true;
      // 查询列表
    },
    getImgCode () {
      const corpId = sessionStorage.getItem("corpId"),
        { dingTalkUserId } = this.dingloginInfo;
      let param = {
        corpId,
        dingTalkUserId
      };
      dingtalkApi.getImgCode(param).then(({ data }) => {
        this.imgAuth = data;
      });
    },
    vaildEmailExit (rule, value, callback) {
      value = value.trim();
      checkTargetExists(value)
        .then(res => {
          if (res && res.data == true) {
            return callback("该邮箱已被注册");
          } else if (!res.success && res.code === "2") {
            return callback("请输入正确格式的邮箱");
          } else {
            return callback();
          }
        })
        .catch(err => {
          console.log(err);
          return callback();
        });
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 跳转页面
    turnPage () {
      if (this.backUrl) window.location.href = this.backUrl;
    }
  },
  // methods end
  components: {},
  // components end
  created () {
    this.dingloginInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
    this.enterprise.enterpriseName = this.dingloginInfo.dingTalkCorpName;
    this.getImgCode();
  },
  computed: {}
};
</script>

<style scoped lang="less">
.person-auth-root {
  width: 100%;
  height: 85vh;
  padding: 10px;
  overflow: auto;
  background-color: #fff;
  .box {
    width: 1000px;
    margin: 0 auto;
    // step3
    .stpe-end {
      height: 45vh;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .res-icon {
        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .text {
          font-size: 1.3vw;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #555555;
          margin-top: 20px;
        }
      }
    }
    // step2
    .stpe-mainland {
      padding-top: 20px;
      margin-top: 0 auto;
      .auth-box {
        width: 30vw;
        padding: 30px;
        margin: 0 auto;
      }
      .auth-type {
        padding: 20px;
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      .font-title {
        font-size: 20px;
        font-weight: bold;
      }
      .list-box {
        height: 57vh;
        overflow-y: auto;
        .auth-list {
          padding: 10px 20px;
          margin: 20px 0;
          border-radius: 4px;
          border: 1px solid #ccc;
          &:hover {
            background-color: #ebeef5;
          }
        }
        .active-auth {
          border: 1px solid #ec1c1c;
        }
      }
      .step2-box {
        margin-top: 20px;
        border: 1px solid #e5e5e5;
      }
    }
    // step1
    .tips {
      padding: 10px;
      margin: 15px auto;
      padding-left: 40px;
      background-color: #fef7f7;
      color: #777777;
      font-size: 14px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
    }
    // btn
    .step-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px auto;
      > div {
        display: flex;
        margin-bottom: 20px;
      }
    }
    .step-box {
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      > div {
        width: 331px;
        height: 63px;
        line-height: 61px;
        text-align: center;
      }
    }
    .step1 {
      background-image: url("/images/auth/authIcon/step1.png");
      background-size: cover;
    }
    .doing {
      background-image: url("/images/auth/authIcon/doing.png");
      background-size: cover;
    }
    .un-start {
      background-image: url("/images/auth/authIcon/un-start.png");
      background-size: cover;
    }
    .font-family {
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .font-21 {
      font-size: 21px;
    }
  }
}
.info-box {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #e5e5e5;
  .card-box {
    .item-box {
      display: inline-block;
      position: relative;
      .img-box {
        display: none;
        .delete-sty {
          font-size: 30px;
          cursor: pointer;
        }
      }

      &:hover {
        .img-box {
          opacity: 0.5;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          //margin-top: -257px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ccc;
        }
      }
    }
    .card-face {
      display: flex;
      margin: 10px 0 20px 0;
      .preview-box {
        height: 205px;
        position: relative;
        &:hover .img-box {
          opacity: 1;
        }
        .card-img {
          margin-left: 0;
        }
        .img-box {
          opacity: 0;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
    }

    .card-img {
      height: 205px;
      margin-left: 30px;
    }
  }
}
.img-code {
  background-color: #fff;
  display: inline-block;
  margin: 0 -20px;
  width: 100px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;

  img {
    vertical-align: middle;
    display: inline-block;
    height: 38px;
    width: 100%;
  }
}
.input-width {
  width: 25vw !important;
}
.red-border {
  border: 1px solid #ec1c1c !important;
}
</style>



// WEBPACK FOOTER //
// pages/dingtalkUse/authentication.vue